import { useEffect } from "react";
import useUSUndo from "../../../hooks/useUSUndo";

const useLoadPositionToEdit = (
  axiosPrivate,
  positiontoedit,
  setUSposition,
  setUSpositionData,
  setPaymentterm,
  setPaymenttermData,
  paytermInit,
  paytermDataInit,
  setLoaded,
  navigate,
  location
) => {
  const { positionEdits, undoList } = useUSUndo();
  useEffect(() => {
    if (positiontoedit) {
      const loaduspositiontoedit = async () => {
        try {
          const response = await axiosPrivate.post("/api/positions/loaduspositiontoedit", {
            positionID: positiontoedit,
          });
          // console.log(response.data[0]);
          setUSposition(response.data[0]);
          // setUSpositionUnedited(response.data[0]);
          setLoaded((prev) => !prev);
          positionEdits.current = [];
          undoList.current = [];
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      const loaduspositiondatatoedit = async () => {
        try {
          const response = await axiosPrivate.post("/api/positions/loaduspositiondatatoedit", {
            positionID: positiontoedit,
          });
          // console.log(response.data[0]);
          setUSpositionData(response.data[0]);
          // setUSpositionDataUnedited(response.data[0]);
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      const loadUSpospayterms = async () => {
        try {
          const response = await axiosPrivate.post("/api/positions/loadUSpospayterms", {
            positionID: positiontoedit,
          });
          if (response.data.message === "No payterms exist.") {
            setPaymentterm(paytermInit);
          } else setPaymentterm(response.data);
        } catch {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      const loadUSpospaytermsdata = async () => {
        try {
          const response = await axiosPrivate.post("/api/positions/loadUSpospaytermsdata", {
            positionID: positiontoedit,
          });
          if (response.data.message === "No payterms exist.") {
            setPaymenttermData(paytermDataInit);
          } else setPaymenttermData(response.data);
        } catch {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      loaduspositiontoedit();
      loaduspositiondatatoedit();
      loadUSpospayterms();
      loadUSpospaytermsdata();
    }
  }, [positiontoedit]);
};

export default useLoadPositionToEdit;
